export enum CATEGORY_TYPE {
    EDUCATION = 1,
    ENTERTAINMENT = 2,
}
